import { forwardRef, memo, useState } from 'react';
import { Input, InputProps } from '../Input';
import { Eye } from 'src/components/svg/Eyes';

export type PasswordInputProps = InputProps;

const _PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ label, ...inputPasswordProps }, ref) => {
    const [passwordShown, setPasswordShown] = useState(false);

    return (
      <div className="flex flex-col justify-between h-full items-start gap-2 w-[100%]">
        {label ? <label className="text-base text-sap_label">{label}</label> : null}
        <Input
          className="placeholder:text-i_placeholder"
          {...inputPasswordProps}
          ref={ref}
          type={passwordShown ? 'text' : 'password'}
          rightIcon={
            <Eye
              setPasswordShown={setPasswordShown}
              passwordShown={passwordShown}
              className="h-5"
            />
          }
        />
      </div>
    );
  }
);

_PasswordInput.displayName = 'PasswordInput';

export const PasswordInput = memo(_PasswordInput);
